import { Box, Divider, Grid, Typography } from '@material-ui/core';
import { Theme, makeStyles } from '@material-ui/core/styles';
import { Button } from '@roc/ui';
import { observer } from 'mobx-react';
import { useHistory } from 'react-router';
import { isNil } from '@roc/feature-utils';
import { useAppRoutes } from 'apps/client-portal-public/src/app/hooks';

const useStyles = makeStyles((theme: Theme) => ({
  paper: {
    margin: '40px'
  },
  loanIdBox: {
    paddingLeft: '8px',
    paddingTop: '10px',
    paddingBottom: '10px'
  },
  secondaryTextBox: {
    paddingLeft: '8px',
    paddingBottom: '10px'
  },
  thankYouText: {
    fontSize: '40px'
  },
  otherTexts: {
    fontSize: '15px'
  },
  divider: {
    marginTop: '20px',
    marginBottom: '20px'
  },
  button: {
    width: '250px'
  }
}));

export const SuccessPage = observer(({ store, currentRoutes, isFromBorrowerPortal }) => {
  const { push } = useHistory();
  const { newPublicLoanId } = store;

  const encodeParams = (data) => {
    return window.btoa(encodeURIComponent(data));
  }

  const classes = useStyles();
  return (
    <>
      <Grid container>
        <Grid xs={12} md={12}>
          <Box
            height="100%"
            width="100%"
            margin="auto"
            display={'flex'}
            flexDirection={'column'}
          >
            <Box>
              <Typography className={classes.thankYouText}>Thank You!</Typography>
            </Box>
            {!isNil(newPublicLoanId) ?
              <Box className={classes.loanIdBox}>
                <Typography className={classes.otherTexts}>
                  Your loan submission ID number is {newPublicLoanId}
                </Typography>
              </Box>
              :
              <></>
            }
            <Box className={classes.secondaryTextBox}>
              <Typography className={classes.otherTexts}>
                We will notify you via email once the loan submission is accepted.
              </Typography>
            </Box>
            {!isFromBorrowerPortal && <>
              <Box>
                <Divider className={classes.divider} />
              </Box>
              <Box className={classes.secondaryTextBox}>
                <Typography className={classes.otherTexts}>
                  Would you like to apply for another loan?
                </Typography>
              </Box>
              <Box className={classes.secondaryTextBox}>
                <Button
                  testId="start-another-loan"
                  variant="contained"
                  className={classes.button}
                  onClick={() => {
                    store.resetForNewLoanApplication();
                    push(currentRoutes.url)
                  }}
                >
                  START ANOTHER LOAN
                </Button>
              </Box>
            </>}
          </Box>
        </Grid>
      </Grid>
    </>
  );
});
